import { render } from "./TestSite.vue?vue&type=template&id=081b7d22"
import script from "./TestSite.vue?vue&type=script&lang=ts"
export * from "./TestSite.vue?vue&type=script&lang=ts"

import "./TestSite.vue?vue&type=style&index=0&id=081b7d22&lang=scss"
script.render = render

export default script